import { create } from "zustand";

interface InventoryState {
  /** Server catalog version we're in sync with (null until the first poll). */
  version: number | null;
  /** Live stock levels that override what's in cached product data. */
  overlay: Record<string, number>;
  apply: (version: number, changes: { sku: string; inventory: number }[]) => void;
  reset: (version: number) => void;
}

export const useInventory = create<InventoryState>((set) => ({
  version: null,
  overlay: {},
  apply: (version, changes) =>
    set((s) => {
      const overlay = { ...s.overlay };
      for (const c of changes) overlay[c.sku] = c.inventory;
      return { version, overlay };
    }),
  reset: (version) => set({ version, overlay: {} }),
}));
